import React from "react";
import JournalEntryDrawer from "../../../components/common/jouralEntryDrawer/journalEntryDrawer";
import { Link, Typography } from "@mui/material";
import useLogAccessEvent from "../../../hooks/useLogAccessEvent";
import { AccessEventIndividualDetails } from "../../../services/types/accessEventTypes";

export type ResourceNotesDrawerProps = {
    pKey: string;
    imKey: string;
    email: string;
    open: boolean;
    onClose: () => void;
    onSave: () => void;
};

const ResourceNotesDrawer: React.FC<ResourceNotesDrawerProps> = (props) => {
    const { logEvent } = useLogAccessEvent();
    const catData = { resourceKey: props.pKey, resourceEmail: props.email };

    function saveEntry() {
        const evtData: AccessEventIndividualDetails = {
            imKey: props.imKey,
            email: props.email,
        };
        logEvent("ResourceNoteAdded", evtData);
        props.onSave();
    }

    return (
        <JournalEntryDrawer
            journalCategory={4}
            journalCategoryData={[JSON.stringify(catData)]}
            journalHistory={[]}
            alert={
                <Typography>
                    Please note: Any notes entered here will not display in IAS. This
                    feature is for proof of concept and user feedback purpose only. Notes will
                    remain in IAS until this proof of concept is finalized, including templates for
                    notes. If you wish to provide any feedback please contact Andy Wilson
                    (<Link href="mailto:wilsona@ccl.org">wilsona@ccl.org</Link>).
                </Typography>
            }
            alertColor="error"
            open={props.open}
            notes={true}
            onClose={() => props.onClose()}
            onSave={() => saveEntry()}
            onSaveError={(msg: string) => console.log(msg)}
        />
    );
};

export default ResourceNotesDrawer;
